import { useState, useEffect, useMemo } from 'react';
import Auth from '@aws-amplify/auth';
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components';

export default ({ options }) => {
  const [state, setState] = useState({
    user: {},
    isSignedIn: false,
  });

  const [currentSession, setSession] = useState({});
  const [token, setToken] = useState(null);

  const auth = useMemo(() => {
    Auth.configure(options);
    return Auth;
  }, []);

  useEffect(() => {
    auth.currentAuthenticatedUser()
      .then((user) => {
        setState({ user, isSignedIn: true });
      })
      .catch(() => {});
    auth.currentSession()
      .then((sessionResponse) => {
        setSession(sessionResponse);
        setToken(sessionResponse.getAccessToken().getJwtToken());
      })
      .catch(() => { });
    return onAuthUIStateChange((nextAuthState, authData) => {
      setState({ user: authData, isSignedIn: nextAuthState === AuthState.SignedIn });
    });
  }, []);

  return {
    ...state,
    token,
    currentSession,
  };
};
